import { render, staticRenderFns } from "./IlLoading.vue?vue&type=template&id=1bc6ef2d&scoped=true&"
import script from "./IlLoading.vue?vue&type=script&lang=js&"
export * from "./IlLoading.vue?vue&type=script&lang=js&"
import style0 from "./IlLoading.vue?vue&type=style&index=0&id=1bc6ef2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc6ef2d",
  null
  
)

export default component.exports